"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _Mon307TalkToSalesAuthedCta = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307TalkToSalesAuthedCta"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    top: 83px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  position: sticky;\n  align-items: center;\n  padding: 20px;\n  z-index: 99;\n  top: 69px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledStickyBar = _styledComponents.default.div.withConfig({
  displayName: "Mon307StickyTtsBar__StyledStickyBar",
  componentId: "sc-19ycqvg-0"
})(_templateObject(), _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject2()));

var Mon307StickyTtsBar = function Mon307StickyTtsBar(_ref) {
  var hub = _ref.hub,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["hub", "className"]);
  return _react.default.createElement(StyledStickyBar, (0, _extends2.default)({
    className: (0, _classNames.default)('justify-center', className)
  }, rest), _react.default.createElement("div", {
    className: "m-right-4",
    style: {
      fontWeight: '500',
      fontSize: 18
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "mon307.needHelp"
  })), _react.default.createElement(_Mon307TalkToSalesAuthedCta.default, {
    location: _Tracking.STICKY_BELOW_TABS,
    hub: hub
  }));
};

var _default = Mon307StickyTtsBar;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/Mon307StickyTtsBar.js
// module id = 262
// module chunks = 5 6